module.exports = __webpack_public_path__ + "05_hair_black.fc7b1c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/05_hair_black.png
// module id = Maxw
// module chunks = 0